var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleChoiceGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 4.5,
    r: 2,
    fill: "#1B2436"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 9.5,
    r: 2,
    fill: "#1B2436"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 14.5,
    r: 2,
    fill: "#1B2436"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 4.5,
    r: 2,
    fill: "#1B2436"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 9.5,
    r: 2,
    fill: "#1B2436"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.5,
    r: 2,
    fill: "#1B2436"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 4.5,
    r: 2,
    fill: "#1B2436"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 2,
    fill: "#1B2436"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 14.5,
    r: 2,
    fill: "#1B2436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoiceGrid);
export default __webpack_public_path__ + "static/media/multipleChoiceGrid.586a0f0021f5c558bc3a01e2671b6997.svg";
export { ForwardRef as ReactComponent };